<script lang="ts">
interface Props {
    children?: import('svelte').Snippet;
}

let { children }: Props = $props();
</script>

<div class="section-text">
    {@render children?.()}
</div>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use '/src/scss/mixins/builder-rich-text' as builder-mixins;
    @use 'sass-mq/mq' as *;

    .section-text {
        font-family: fonts.$fonts-secondary;
        font-weight: fonts.$fonts-weight--normal;
        white-space: pre-line;
        font-size: 1.8rem;
        line-height: 3rem;

        @include mq($from: tablet) {
            font-size: 2rem;
            line-height: 2.6rem;
        }

        @include builder-mixins.rich-text-links;

        :global(p:not(:last-child)) {
            margin-bottom: 15px;
        }

        :global(b),
        :global(strong) {
            font-weight: fonts.$fonts-weight--medium;
        }

        :global(em),
        :global(i) {
            font-style: italic;
        }

        :global(ul),
        :global(ol) {
            margin-top: 0;
            overflow: hidden;
            margin-bottom: 0;
            padding-left: 22px;
        }

        :global(ul ::marker),
        :global(ol ::marker) {
            font-family: fonts.$fonts-secondary;
            color: var(--colour-black-out);
            font-size: 0.9em;
        }

        :global(ol) {
            list-style: decimal;
        }

        :global(ul) {
            list-style: disc;
        }

        :global(li) {
            margin-bottom: 15px;
        }
    }
</style>
